/**
 * Exceldownload working with NSWOW2 Tables
 */

class XTableNamer {
  constructor() {
    const elements = Array.prototype.slice.call(document.querySelectorAll('.content .ns-table-wrap, .content .ns-title-h1, .content .ns-title-h2, .content .ns-title-h5, .content .accordion__title'));

    let h1;
    let h2;
    let c;
    const pageTitle = document.querySelector('[class*="ns-title-"]');

    elements.forEach(element => {
      const className = element.classList[0];

      switch (className) {
        case "ns-title-h1":
          h1 = element.innerText || ''; // Ensure h1 is a string
          c = 0;
          break;
        case "ns-title-h2":
          if (element.innerText && element.innerText.trim()) { // Check if innerText exists
            h2 = element.innerText;
            c = 0;
          }
          break;
        case "ns-title-h5":
          if (element.innerText && element.innerText.trim()) {
            h1 = element.innerText;
            c = 0;
          }
          break;
        case "accordion__title":
          const spanL = element.querySelector('span:last-child');
          if (spanL && spanL.innerText && spanL.innerText.trim()) { // Ensure spanL and its innerText exist
            h2 = spanL.innerText;
            c = 0;
          }
          break;
        case "ns-table-wrap":
          let title = '';
          let fileTitle = '';

          let xlsxTitle = element.querySelector('.ns-table-xlsx-title');
          if (xlsxTitle) {
            title = xlsxTitle.innerText.trim();
            fileTitle = title.replace(/\s/g, '_');
            xlsxTitle.remove();
          } else {
            if (pageTitle && pageTitle.innerText) { // Ensure pageTitle exists
              title += pageTitle.innerText + ' – ';
            }
            if (h1) {
              title += h1.trim();
            }
            if (h2) {
              title += ' - ' + h2.trim();
              fileTitle += h2.trim().replace(/\s/g, '_');
            } else if (h1) {
              fileTitle += h1.trim().replace(/\s/g, '_');
            }
            if (c > 0) {
              title += ' ' + (c + 1);
              fileTitle += '_' + (c + 1);
            }
          }

          element.dataset.xTitle = title;
          element.dataset.xFileTitle = fileTitle;
          c++;
          break;
      }
    });
  }
}

export default XTableNamer;
